module.exports = __webpack_public_path__ + "media/images/core_values/motivation-97dc1bcb948ec62ac5301b1de4c33d84.png";